// AI-generated care plan text (Careplan Notes, Recommendations) marks
// emphasis with literal "**double asterisks**", matching common LLM
// output conventions - not full markdown, just this one marker. Splits a
// string into { text, bold } segments so each renderer (plain HTML spans,
// or react-pdf's own Text nodes, which can't interpret HTML tags at all)
// can style the bold segments itself rather than pulling in a full
// markdown parser for a single marker.
export function parseBoldSegments(value) {
  const text = value || "";
  const pattern = /\*\*(.+?)\*\*/g;
  const segments = [];
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(text))) {
    if (match.index > lastIndex) {
      segments.push({ text: text.slice(lastIndex, match.index), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ text: text.slice(lastIndex), bold: false });
  }

  return segments.length ? segments : [{ text, bold: false }];
}

// SCRUM-788: AI-added/updated content within a "**bold**" span additionally
// carries a trailing "(added MM/DD/YYYY)" or "(updated MM/DD/YYYY)" tag
// inside the bold text itself - e.g. "**New finding(added 09/20/2026)**".
// That tag needs to render as its own small chip next to the bold text, not
// as literal bold characters, so this splits it back out of each bold
// segment parseBoldSegments produced. Plain (non-bold) segments and bold
// segments with no trailing tag pass through unchanged (dateTag: null) -
// re-running AI on already-tagged text is naturally idempotent here since
// this only ever reads the stored string, never rewrites it.
const DATE_TAG_PATTERN = /\s*\(\s*(added|updated)\s+(\d{1,2}\/\d{1,2}\/\d{2,4})\s*\)\s*$/i;

export function parseSegmentsWithDateTags(value) {
  return parseBoldSegments(value).map((segment) => {
    if (!segment.bold) return { ...segment, dateTag: null };
    const match = segment.text.match(DATE_TAG_PATTERN);
    if (!match) return { ...segment, dateTag: null };
    return {
      ...segment,
      text: segment.text.slice(0, match.index),
      dateTag: { kind: match[1].toLowerCase(), date: match[2] },
    };
  });
}
